import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { mensagemDeErro, solicitarNovaSenha } from "services/auth";
import { AvisoErro, CartaoAcesso } from "./components/CartaoAcesso";

const MENSAGEM_ENVIO =
  "Se o e-mail estiver cadastrado, você receberá as instruções para criar uma nova senha.";

/**
 * "Esqueci minha senha" (plano de 07/10/2026, B2). A mensagem é sempre a mesma — não revela se o
 * e-mail está cadastrado (decisão P2 de 08/10).
 */
export function EsqueciSenha() {
  const [email, setEmail] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviado, setEnviado] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const handleSubmit = async (evento: FormEvent) => {
    evento.preventDefault();
    setErro(null);

    if (!email.trim()) {
      setErro("Informe o e-mail.");
      return;
    }

    setEnviando(true);
    try {
      const mensagem = await solicitarNovaSenha(email.trim());
      setEnviado(mensagem || MENSAGEM_ENVIO);
    } catch (e: any) {
      setErro(
        e?.status === 429 || e?.status === 400
          ? mensagemDeErro(e, "Não foi possível enviar agora. Tente novamente mais tarde.")
          : "Não foi possível enviar agora. Tente novamente mais tarde."
      );
    } finally {
      setEnviando(false);
    }
  };

  return (
    <CartaoAcesso
      titulo="Esqueci minha senha"
      rodape={
        <Link to="/login" className="link-secondary">
          Voltar para o login
        </Link>
      }
    >
      {enviado ? (
        <div className="alert alert-success" role="status">
          {enviado}
        </div>
      ) : (
        <form onSubmit={handleSubmit} noValidate>
          <p className="text-muted">
            Informe o e-mail cadastrado. Enviaremos um link para você criar uma nova senha.
          </p>
          <AvisoErro mensagem={erro} />
          <div className="mb-3">
            <label className="form-label" htmlFor="esqueci-email">
              E-mail
            </label>
            <input
              id="esqueci-email"
              type="email"
              className="form-control"
              placeholder="Email..."
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
            />
          </div>
          <button type="submit" className="btn btn-mof w-100" disabled={enviando}>
            {enviando ? "ENVIANDO..." : "ENVIAR"}
          </button>
        </form>
      )}
    </CartaoAcesso>
  );
}
